import React from "react";
import Fade from "react-reveal/Fade";
import "./SkillCard.scss";

const SkillCard = (props) => {
  return (
    <Fade>
      <li className="skill-item">
        <div className="image">
          <img
            loading="lazy"
            className="skill-logo"
            src={props.imgURL}
            alt={props.name}
          />
        </div>
      </li>
    </Fade>
  );
};

export default SkillCard;
